/**
 * Roles that must not open the Reimbursements module.
 *
 * Angular: sidebar is gated on `default_menu` only — these roles do not get that
 * policy (or must be blocked even if a tile/deep-link reaches `/defaults`).
 * React mirrors that with Access Denied + redirect to dashboard.
 */
export const REIMBURSEMENTS_ACCESS_DENIED_ROLES = [
  'EXTERNAL_INSURANCE',
  'ROLE_LIBERTY_FIN_MGR',
] as const

export function isReimbursementsAccessDeniedRole(
  roleName: string | null | undefined,
): boolean {
  if (!roleName) return false
  return (REIMBURSEMENTS_ACCESS_DENIED_ROLES as readonly string[]).includes(roleName)
}
